<template>
  <div :class="$options.name">
    <input
      v-model="valueText"
      type="text"
      class="search-input"
      :placeholder="placeholder"
      @input="onInput"
      @change="onChange"
    />
    <i
      :class="valueText.length > 0 ? 'icon-x' : 'icon-search'"
      @click="clearKeyword"
    ></i>
  </div>
</template>

<script>
export default {
  name: 'SearchInputBox',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      valueText: '',
    }
  },
  watch: {
    modelValue(txt) {
      this.valueText = txt
    },
  },
  mounted() {
    this.valueText = this.modelValue
  },
  methods: {
    onInput(e) {
      this.$emit('update:modelValue', e.target.value)
    },
    onChange(e) {
      this.$emit('change', e)
    },
    clearKeyword() {
      this.valueText = ''
      this.$emit('modelValue', '')  // Change this line to emit 'modelValue' instead of 'update:ModelValue'
      this.$emit('update:modelValue', '')  // This line is also correct
      this.$emit('change', { target: { value: '' } })
    },
  },
}
</script>


<style lang="scss" scoped>
.SearchInputBox {
  position: relative;
  color: #d9d9d9;

  /deep/ input {
    @include montserrat-font(16px, $black2, 'light');
    height: 40px;
    padding: 10px 18px;
    border: 1px solid #d9d9d9;
    &::placeholder {
      @include montserrat-font(16px, $text_placeholder, 'normal');
    }
    &:focus {
      border: 1px solid $tertiary;
      outline: unset;
    }
  }

  .icon-search {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    right: 20px;
    &::before {
      color: #d9d9d9;
    }
  }

  .icon-x {
    cursor: pointer;
    @extend .icon-search;
    top: 50%;
    transform: translate(0, -40%);
    font-size: 2rem;
  }
}
</style>
